import React, {Component} from 'react';
import {FancyRadiobox} from '../widgets/index';
import './UserType.css';
import {connect} from 'react-redux';
import confirmActions from '../widgets/confirmation.actions';

export class UserType extends Component {
	constructor() {
		super();

		const onCheck = type => () => {
			if (type === this.props.checked) return;

			if (this.props.confirm) {
				this.props.onOpenConfirmation(type, this.props.onChange);
			} else {
				this.props.onChange(type);
			}
		};
		this.onCheckUser = onCheck('user');
		this.onCheckProvider = onCheck('provider');
	}

	render() {
		const {checked = 'user'} = this.props;

		return (
			<div className={`UserType ${checked || 'user'}`}>
				<ul>
					<li className={checked === 'provider' ? 'checked' : ''} onClick={this.onCheckProvider}>
						<span className="icon icon-face" />
						<div className="UserType-details">
							<div className="UserType-name">Provider</div>
							<div className="UserType-caption">I want to advertise my services</div>
						</div>
						<FancyRadiobox
							checked={checked === 'provider'}
							title=""
							onCheck={this.onCheckProvider}
						/>
					</li>
					<li className={checked === 'user' ? 'checked' : ''} onClick={this.onCheckUser}>
						<span className="icon icon-person" />
						<div className="UserType-details">
							<div className="UserType-name">User</div>
							<div className="UserType-caption">I'm looking for providers</div>
						</div>
						<FancyRadiobox checked={checked === 'user'} title="" onCheck={this.onCheckUser} />
					</li>
				</ul>
			</div>
		);
	}
}

const ConnectedUserType = connect(
	({confirmation}) => ({
		confirmation
	}),
	dispatch => ({
		onOpenConfirmation: (type, onConfirm) =>
			dispatch(
				confirmActions.open({
					title: `Do you really want to become a ${type}?`,
					message:
						'This will affect how you appear in search results, and the visibity of your profile to others.',
					onConfirm,
					data: type
				})
			)
	})
)(UserType);

export default ConnectedUserType;



// WEBPACK FOOTER //
// ./src/user/UserType.js